import * as angular from 'angular';

import { ComponentDefinition } from '../../../models';

class StackedLogsStateController implements angular.IComponentController {
    loadingMessage: string;
    readonly isLoading: boolean;
    readonly logs: any[]; // Type to be determined
    static $inject = [];
}

export const wtStackedLogsState: ComponentDefinition = {
    componentId: 'wtStackedLogsState',
    controller: StackedLogsStateController,
    template: require('./stackedLogsState.component.html'),
    controllerAs: 'vm',
    bindings: {
        logs: '<',
        isLoading: '<'
    }
};
